export interface IMaintenanceType {
    id: number,
    name: string
}

export enum MaintenanceType {
    Damage = 1,
    Document = 2
}